var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCloseFill = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.24
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1739 9.99929L14.7537 6.42723C15.0802 6.10073 15.0802 5.57137 14.7537 5.24487C14.4273 4.91838 13.898 4.91838 13.5715 5.24487L10 8.82526L6.42845 5.24487C6.102 4.91838 5.57271 4.91838 5.24626 5.24487C4.91981 5.57137 4.91981 6.10073 5.24626 6.42723L8.82613 9.99929L5.24626 13.5713C5.08865 13.7277 5 13.9405 5 14.1625C5 14.3845 5.08865 14.5974 5.24626 14.7537C5.40258 14.9113 5.61537 15 5.83736 15C6.05934 15 6.27213 14.9113 6.42845 14.7537L10 11.1733L13.5715 14.7537C13.7279 14.9113 13.9407 15 14.1626 15C14.3846 15 14.5974 14.9113 14.7537 14.7537C14.9113 14.5974 15 14.3845 15 14.1625C15 13.9405 14.9113 13.7277 14.7537 13.5713L11.1739 9.99929Z",
    fill: "white"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCloseFill);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/close_fill_.373bae675bb9e62984fc27c6e1fd24f2.svg";